<template>
    <div class="safe-content">
        <div class="safe-bar">
            <div>个人信息</div>
            <router-link v-for="i in safeData"
                :key="i.url" :to="i.url"
                :class="{'active': i.url == $route.path 
                    || ($route.path == '/' && i.url == '/information') 
                    || ($route.path == '/settingHome' && i.url == '/securitySetting') 
                    || ($route.path == '/updatePassword' && i.url == '/securitySetting') 
                    || ($route.path == '/bindingCellPhone' && i.url == '/securitySetting' ),'router-link':true}">
                <span :class="i.icon"> {{i.name}}
                    <i class="el-icon-arrow-right"></i>
                </span>
            </router-link>
        </div>
    </div>
</template>

<script>

export default {
    components: {
        
    },
    data () {
        return {
            safeData: [{
                name: '基本信息',
                url: '/information',
                icon: 'el-icon-document'
            },{
                name: '安全设置',
                url: '/securitySetting',
                icon: 'el-icon-setting'
            },
            // {
            //     name: 'otp绑定',
            //     url: '/bindingOtp',
            //     icon: 'el-icon-connection'
            // }
            // ,{
            //     name: '操作记录',
            //     url: '/operationLog',
            //     icon: 'el-icon-edit-outline'
            // },{
            //     name: '访问记录',
            //     url: '/visitLog',
            //     icon: 'el-icon-phone-outline'
            // },{
            //     name: '注销账号',
            //     url: '/logonAccount',
            //     icon: 'el-icon-circle-close-outline'
            // }
            ]
        }
    },
    methods: {
        
    },
    mounted() {
        
    }
}
</script>

<style lang="scss" scoped>
    .safe-content{
        width: 180px; height: 100%;
        .safe-bar{
            width: 100%; height: 100%; border-right: 1px solid #cecece; background: #ffffff;
            div{
                width: 100%; line-height: 40px; display: block; padding-left: 18px; border-bottom: 1px solid #e8e9ef; font-size: 14px;
            }
            .router-link{
                width: 100%; line-height: 48px; display: block; padding-left: 18px; border-bottom: 1px solid #e8e9ef; font-size: 13px; color: #333333;
                span{
                    width: 100%; padding-right: 12px;
                    i{
                        float: right; color: #aaaaaa;
                    }
                }
            }
            .active{
                background: #3AA2EB; color: #ffffff;
                span{
                    i{
                        color: #ffffff;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/SafeBar.vue